import React, { useState } from "react";
import { Link } from "react-router-dom";

// Static data - replace with your API data later
const reportData = {
  todayExecutiveReport: {
    totalLeads: 8,
    executives: [
      {
        executiveId: "",
        executiveName: "Unassigned",
        leadsCount: 1,
        leads: [
          {
            phone: "75675676756",
            name: "backendTestDirect",
            assignedTo: "",
            actionsToday: [
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T06:47:31.615+00:00",
              },
            ],
            leadId: "6927f403f4fd3704fc2e4928",
          },
        ],
      },
      {
        executiveId: "68e3a7399d677d6f477ab812",
        executiveName: "Crezanta K",
        leadsCount: 7,
        leads: [
          {
            lastFollowUpAt: "2025-11-20T07:47:31.828+00:00",
            nextFollowUpDate: "2025-11-21",
            phone: "1234567890",
            lastRemark: "Spoke to client sd cb tmrw for Demo at 3,00pm",
            name: "test",
            assignedTo: "Crezanta K",
            actionsToday: [],
            leadId: "691d930d1679f735e320ee1a",
            pendingFollowUp: true,
          },
          {
            lastFollowUpAt: "2025-11-21T13:39:20.192+00:00",
            nextFollowUpDate: "2025-11-22",
            phone: "98700008212",
            lastRemark: "Call him on 22nd nov",
            name: "Manish Bavishi",
            assignedTo: "Crezanta K",
            actionsToday: [],
            leadId: "691d93131679f735e320ef5b",
            pendingFollowUp: true,
          },
          {
            lastFollowUpAt: "2025-11-27T10:22:50.994+00:00",
            nextFollowUpDate: "2025-11-27",
            phone: "9712908620",
            lastRemark: "test",
            name: "Shree Kutch Mewada Suthar Samajwadi",
            assignedTo: "Crezanta K",
            actionsToday: [
              {
                performedById: "",
                performedByName: "",
                actionType: "FOLLOWUP_ADDED",
                actionDetails:
                  "Follow-up added by for date: 2025-11-27 time: 15:52",
                timestamp: "2025-11-27T10:22:51.088+00:00",
              },
            ],
            leadId: "691d93161679f735e320efcd",
            pendingFollowUp: true,
          },
        ],
      },
      {
        executiveId: "68e3a7399d677d6f477ab813",
        executiveName: "Nikhil Kadam",
        leadsCount: 5,
        leads: [
          {
            phone: "9818627588",
            name: "neha",
            assignedTo: "Nikhil Kadam",
            actionsToday: [
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
            ],
            leadId: "6928026191f5885e90ab8e5d",
          },
        ],
      },
      {
        executiveId: "68e3a7399d677d6f477ab813",
        executiveName: "Nikhil Kadam",
        leadsCount: 5,
        leads: [
          {
            phone: "9818627588",
            name: "neha",
            assignedTo: "Nikhil Kadam",
            actionsToday: [
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
              {
                performedById: "68dd1fbf500c6062b2e0a2e8",
                performedByName: "NIkhil Kadam",
                actionType: "LEAD_CREATED",
                actionDetails: "Lead created manually",
                timestamp: "2025-11-27T07:48:49.199+00:00",
              },
            ],
            leadId: "6928026191f5885e90ab8e5d",
          },
        ],
      },
    ],
  },
  noActivityLeads: [
    {
      phone: "1234567890",
      name: "test",
      assignedTo: "Crezanta K",
      leadId: "691d930d1679f735e320ee1a",
    },
    {
      phone: "9730797373",
      name: "MASHA ALLAH PALACE",
      assignedTo: "Crezanta K",
      leadId: "691d930d1679f735e320ee1d",
    },
    {
      phone: "9226432075",
      name: "Patils Eden Garden",
      assignedTo: "Crezanta K",
      leadId: "691d930d1679f735e320ee20",
    },
  ],
  dueFollowups: {
    overdue: [
      {
        _id: "691c6d1e65a65857433bfda7",
        leadId: "691c6d1e65a65857433bfda7",
        lastRemark: "call him ",
        nextFollowUpDate: "2025-11-19T18:30:00.000+00:00",
        assignedTo: "NIkhil Kadam",
        name: "Test Lead 1",
        phone: "784896787346",
        statusName: "New",
        leadAssignedTo: null,
      },
      {
        _id: "68e4f5dcb938781d368d0562",
        leadId: "68e4f5dcb938781d368d0562",
        lastRemark: "call on it",
        nextFollowUpDate: "2025-10-13T18:30:00.000+00:00",
        assignedTo: "NIkhil Kadam",
        name: "Test Lead 2",
        phone: "784896787346",
        statusName: "Follow-up",
        leadAssignedTo: null,
      },
    ],
    dueToday: [
      {
        _id: "691d93161679f735e320efcd",
        leadId: "691d93161679f735e320efcd",
        lastRemark: "test",
        nextFollowUpDate: "2025-11-26T18:30:00.000+00:00",
        assignedTo: "NIkhil Kadam",
        name: "Test Lead Today",
        phone: "784896787346",
        statusName: "Due Today",
        leadAssignedTo: null,
      },
    ],
  },
};

// Executive Modal Component
const ExecutiveModal = ({ executive, isOpen, onClose }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getActionTypeColor = (actionType) => {
    switch (actionType) {
      case "LEAD_CREATED":
        return "bg-green-100 text-green-800 border-green-200";
      case "FOLLOWUP_ADDED":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "LEAD_UPDATED":
        return "bg-purple-100 text-purple-800 border-purple-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200 bg-gradient-to-r from-[#F3E8FF] to-[#EDE9FE] rounded-t-xl">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-[#8B5CF6] to-[#673AB7] rounded-full flex items-center justify-center">
              <span className="text-white font-semibold text-lg">
                {executive.executiveName
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </span>
            </div>
            <div>
              <h2 className="text-xl font-bold cfg-heading">
                {executive.executiveName}
              </h2>
              <p className="text-gray-600">
                {executive.leadsCount} lead
                {executive.leadsCount !== 1 ? "s" : ""}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg
              className="w-6 h-6 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            {executive.leads.map((lead, index) => (
              <div
                key={lead.leadId}
                className="bg-gray-50 rounded-lg border border-gray-200 p-4"
              >
                {/* Lead Header */}
                <div className="flex justify-between items-start mb-3">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <h3 className="font-semibold text-gray-900 text-lg">
                        {lead.name}
                      </h3>
                      {lead.pendingFollowUp && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                          ⏰ Follow-up Pending
                        </span>
                      )}
                    </div>
                    <p className="text-gray-600">{lead.phone}</p>
                    {lead.lastRemark && (
                      <p className="text-gray-700 mt-2">
                        <span className="font-medium">Last Remark:</span>{" "}
                        {lead.lastRemark}
                      </p>
                    )}
                    {lead.nextFollowUpDate && (
                      <p className="text-sm text-gray-500 mt-1">
                        Next follow-up: {formatDate(lead.nextFollowUpDate)}
                      </p>
                    )}
                  </div>
                </div>

                {/* Today's Activities */}
                {lead.actionsToday && lead.actionsToday.length > 0 && (
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                      <svg
                        className="w-4 h-4 mr-2 text-green-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      Today's Activities ({lead.actionsToday.length})
                    </h4>
                    <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                      {lead.actionsToday.map((action, actionIndex) => (
                        <div
                          key={actionIndex}
                          className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-gray-100"
                        >
                          <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                          <div className="flex-1">
                            <div className="flex justify-between items-start mb-2">
                              <span className="font-medium text-gray-900">
                                {action.performedByName || "System"}
                              </span>
                              <span className="text-sm text-gray-500">
                                {formatTime(action.timestamp)}
                              </span>
                            </div>
                            <p className="text-gray-700 mb-2">
                              {action.actionDetails}
                            </p>
                            <span
                              className={`inline-block px-3 py-1 text-sm rounded-full border ${getActionTypeColor(
                                action.actionType
                              )}`}
                            >
                              {action.actionType.replace(/_/g, " ")}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {(!lead.actionsToday || lead.actionsToday.length === 0) && (
                  <div className="text-center py-4 bg-white rounded-lg border border-gray-200">
                    <svg
                      className="w-8 h-8 text-gray-400 mx-auto mb-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p className="text-gray-500">No activities today</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function LeadReportToday() {
  const [selectedExecutive, setSelectedExecutive] = useState(null);
  const [showNoActivity, setShowNoActivity] = useState(true);
  const [showDueFollowups, setShowDueFollowups] = useState(true);

  const { todayExecutiveReport, noActivityLeads, dueFollowups } = reportData;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  };

  const handleExecutiveClick = (executive) => {
    setSelectedExecutive(executive);
  };

  const closeModal = () => {
    setSelectedExecutive(null);
  };

  return (
    <div className="min-h-screen bg-[#FAF8FF] p-4 cfg-font">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      {/* Header */}
      <div className="mb-6">
        <Link
          to="/lead/lead"
          className="inline-flex items-center text-sm text-[#673AB7] hover:text-[#5E35A6] mb-3 transition-colors"
        >
          <svg
            className="w-4 h-4 mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back to Leads
        </Link>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl font-bold cfg-heading">
              Today's Lead Report
            </h1>
            <p className="text-gray-600 mt-1">
              Executive performance and lead tracking
            </p>
          </div>
          <div className="bg-white px-4 py-2 rounded-lg border border-gray-200 mt-2 sm:mt-0 shadow-sm">
            <span className="text-sm font-semibold text-gray-700">
              Total Leads:{" "}
            </span>
            <span className="text-sm font-bold text-[#673AB7]">
              {todayExecutiveReport.totalLeads}
            </span>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        {/* Executive Reports - Main Column */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 rounded-t-xl">
              <h2 className="text-lg font-semibold cfg-heading">
                Executive Reports
              </h2>
            </div>
            <div className="p-4">
              <div className="grid gap-4">
                {todayExecutiveReport.executives.map((executive, index) => (
                  <div
                    key={executive.executiveId || index}
                    className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => handleExecutiveClick(executive)}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 bg-gradient-to-r from-[#8B5CF6] to-[#673AB7] rounded-full flex items-center justify-center">
                          <span className="text-white font-semibold">
                            {executive.executiveName
                              .split(" ")
                              .map((n) => n[0])
                              .join("")}
                          </span>
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-900">
                            {executive.executiveName}
                          </h3>
                          <p className="text-sm text-gray-600">
                            {executive.leadsCount} lead
                            {executive.leadsCount !== 1 ? "s" : ""}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        <span className="bg-[#F3E8FF] text-[#673AB7] text-sm px-3 py-1 rounded-full border border-[#E9D5FF]">
                          Executive
                        </span>
                        <svg
                          className="w-5 h-5 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="space-y-6">
          {/* No Activity Leads */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div
              className="px-5 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors rounded-t-xl"
              onClick={() => setShowNoActivity(!showNoActivity)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-orange-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">No Activity</h3>
                    <p className="text-sm text-gray-600">Inactive leads</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="bg-orange-100 text-orange-800 text-sm px-2.5 py-1 rounded-full font-medium">
                    {noActivityLeads.length}
                  </span>
                  <svg
                    className={`w-4 h-4 text-gray-400 transform transition-transform ${
                      showNoActivity ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {showNoActivity && (
              <div className="max-h-80 overflow-y-auto">
                {noActivityLeads.map((lead, index) => (
                  <div
                    key={lead.leadId}
                    className="px-5 py-3 border-b border-gray-100 last:border-b-0 hover:bg-orange-50 transition-colors"
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <h4 className="font-medium text-gray-900">
                          {lead.name}
                        </h4>
                        <p className="text-sm text-gray-600 mt-1">
                          {lead.phone}
                        </p>
                      </div>
                      <div className="text-right ml-3">
                        <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded">
                          Inactive
                        </span>
                        <p className="text-xs text-gray-500 mt-1">
                          {lead.assignedTo}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Due Follow-ups */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div
              className="px-5 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors rounded-t-xl"
              onClick={() => setShowDueFollowups(!showDueFollowups)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      Due Follow-ups
                    </h3>
                    <p className="text-sm text-gray-600">Pending actions</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="bg-red-100 text-red-800 text-sm px-2.5 py-1 rounded-full font-medium">
                    {dueFollowups.overdue.length + dueFollowups.dueToday.length}
                  </span>
                  <svg
                    className={`w-4 h-4 text-gray-400 transform transition-transform ${
                      showDueFollowups ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {showDueFollowups && (
              <div className="space-y-4 p-4">
                {/* Overdue */}
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <span className="font-medium text-red-700 flex items-center">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                      Overdue
                    </span>
                    <span className="bg-red-100 text-red-800 text-xs px-2.5 py-1 rounded-full">
                      {dueFollowups.overdue.length}
                    </span>
                  </div>
                  <div className="space-y-2 max-h-40 overflow-y-auto">
                    {dueFollowups.overdue.map((followup) => (
                      <div
                        key={followup._id}
                        className="bg-red-50 border border-red-200 rounded-lg p-3"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-medium text-gray-900 text-sm">
                            {followup.name}
                          </h4>
                          <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded ml-2 flex-shrink-0">
                            Overdue
                          </span>
                        </div>
                        <p className="text-xs text-gray-600 mb-2">
                          {followup.phone}
                        </p>
                        <p className="text-xs text-gray-700 line-clamp-2 mb-2">
                          {followup.lastRemark}
                        </p>
                        <div className="flex justify-between items-center text-xs text-gray-500">
                          <span>
                            Due: {formatDate(followup.nextFollowUpDate)}
                          </span>
                          <span>{followup.assignedTo}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Due Today */}
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <span className="font-medium text-green-700 flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      Due Today
                    </span>
                    <span className="bg-green-100 text-green-800 text-xs px-2.5 py-1 rounded-full">
                      {dueFollowups.dueToday.length}
                    </span>
                  </div>
                  <div className="space-y-2 max-h-40 overflow-y-auto">
                    {dueFollowups.dueToday.map((followup) => (
                      <div
                        key={followup._id}
                        className="bg-green-50 border border-green-200 rounded-lg p-3"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-medium text-gray-900 text-sm">
                            {followup.name}
                          </h4>
                          <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded ml-2 flex-shrink-0">
                            Today
                          </span>
                        </div>
                        <p className="text-xs text-gray-600 mb-2">
                          {followup.phone}
                        </p>
                        <p className="text-xs text-gray-700 line-clamp-2 mb-2">
                          {followup.lastRemark}
                        </p>
                        <div className="flex justify-between items-center text-xs text-gray-500">
                          <span>{followup.assignedTo}</span>
                          <span>{followup.statusName}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Executive Modal */}
      {selectedExecutive && (
        <ExecutiveModal
          executive={selectedExecutive}
          isOpen={!!selectedExecutive}
          onClose={closeModal}
        />
      )}
    </div>
  );
}
